import {Component, Inject, inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-modals-view',
  imports: [MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatButtonModule],
  standalone: true,
  templateUrl: './modals-view.component.html',
  styleUrl: './modals-view.component.scss'
})
export class ModalsViewComponent {

  private sanitizer: DomSanitizer = inject(DomSanitizer);

  private dialogRef: MatDialogRef<ModalsViewComponent> = inject(MatDialogRef);
  public dataModule;
  public pdfData: SafeResourceUrl = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataModule = data;
    if (this.dataModule.content_type === 'application/pdf') {
      /*const byteCharacters = atob(data.decrypted_file);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'}); // o altro MIME type

      // Crea URL
      const blobUrl = URL.createObjectURL(blob);

      // Usa questo URL nell'iframe
      this.pdfData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);*/

      this.pdfData = this.sanitizer.bypassSecurityTrustResourceUrl(data.decrypted_file);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
